var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('dl',{staticClass:"flex flex-col gap-1 break-words whitespace-break-spaces",on:{"dblclick":function($event){return _vm.$emit('dblclick', $event)}}},_vm._l((_setup.postProperties),function(prop){return _c('div',{key:prop.id,staticClass:"flex flex-col gap-0.5 py-1"},[_c('dt',{ref:_setup.addLabelRef,refInFor:true,class:[
        _setup.props.propertyLabelClass,
        _setup.props.darkMode && 'text-light-text-200',
        !_setup.props.darkMode && 'text-dark-text-200',
      ],domProps:{"textContent":_vm._s(prop.name)}}),_vm._v(" "),_c('dd',{ref:_setup.addValueRef,refInFor:true,class:[
        _setup.props.propertyValueClass,
        _setup.props.darkMode && 'text-light-text-100',
        !_setup.props.darkMode && 'text-dark-text-100',
      ],domProps:{"textContent":_vm._s(_setup.formatValue(prop))}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }